import { render, staticRenderFns } from "./product-link.vue?vue&type=template&id=7d017870&"
import script from "./product-link.vue?vue&type=script&lang=js&"
export * from "./product-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports